module.exports = __webpack_public_path__ + "img/pakete-header.f03215ca.jpg";